import { render, staticRenderFns } from "./FieldExtraPhonemes.vue?vue&type=template&id=0882d988&"
import script from "./FieldExtraPhonemes.vue?vue&type=script&lang=ts&"
export * from "./FieldExtraPhonemes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports